import React, { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import ChunkEditor from '../ChunkEditor/ChunkEditor';
import DropZone from './components/DropZone';
import DocumentList from './components/DocumentList';
import { useDocumentUpload } from './hooks/useDocumentUpload';
import { useDragAndDrop } from './hooks/useDragAndDrop';
import { useChunkProcessing } from './hooks/useChunkProcessing';
import { triggerDownload } from './utils/downloadUtils';

function DocumentProcessor() {
  const [view, setView] = useState('dashboard');
  const [documents, setDocuments] = useState([]);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [validateAccessibility, setValidateAccessibility] = useState(false);
  const apiBaseUrl = process.env.REACT_APP_API_URL || window.location.origin;

  const { handleMultipleUploads } = useDocumentUpload(apiBaseUrl, setDocuments, validateAccessibility);
  const { dragActive, handleDrag, handleDrop } = useDragAndDrop(handleMultipleUploads);
  const { handleSaveAndProcess } = useChunkProcessing(apiBaseUrl, setDocuments);

  const handleOpenEditor = useCallback((doc) => {
    setCurrentDocument(doc);
    setView('editor');
  }, []);

  const handleSaveAndProcessWrapper = useCallback(async (data, doc) => {
    setView('dashboard');
    await handleSaveAndProcess(data, doc);
  }, [handleSaveAndProcess]);

  const handleDownloadClick = useCallback((doc) => {
    triggerDownload(doc);
  }, []);

  const handleCancelEditor = useCallback(() => {
    setCurrentDocument(null);
    setView('dashboard');
  }, []);

  if (view === 'editor' && currentDocument) {
    return (
      <ChunkEditor
        classification={currentDocument.classificationData}
        pdfFile={currentDocument.file}
        onSave={(data) => handleSaveAndProcessWrapper(data, currentDocument)}
        onCancel={handleCancelEditor}
      />
    );
  }

  return (
    <Box sx={{ p: 4, width: '90%', mx: 'auto' }}>
      <DropZone
        dragActive={dragActive}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        validateAccessibility={validateAccessibility}
        onValidateAccessibilityChange={setValidateAccessibility}
      />
      <DocumentList
        documents={documents}
        onEdit={handleOpenEditor}
        onDownload={handleDownloadClick}
      />
    </Box>
  );
}

export default DocumentProcessor;